import type { CoteMur, Rapport } from "./contract";

export type Colonne = CoteMur; // "gauche" | "droite"

/** Le côté de la vue de face **rendue** (sans miroir) qui fait face au mur. */
export function coteMur(colonne: Colonne, miroir: boolean): CoteMur {
  const versLeMur: CoteMur = colonne === "gauche" ? "droite" : "gauche";
  return miroir ? (versLeMur === "gauche" ? "droite" : "gauche") : versLeMur;
}

export const JUSTESSE_MM = 0.5;

export type Verdict =
  | { etat: "sans-mesure" }
  | { etat: "entre"; debord: number; place: number; justesse: boolean }
  | {
      etat: "retourner";
      debord: number;
      place: number;
      debordRetourne: number;
      hauteurSens: number | null;
      sensAJour: boolean;
    }
  | {
      etat: "aucun-sens";
      debord: number;
      place: number;
      hauteurSens: number | null;
      sensAJour: boolean;
      hauteurRetourne: number | null;
    };

export function verdict(rapport: Rapport, colonne: Colonne, miroir: boolean): Verdict {
  const place = rapport.serre_livre_degagement_mm;
  const gauche = rapport.debord_gauche_mm;
  const droite = rapport.debord_droit_mm;
  if (place == null || gauche == null || droite == null) return { etat: "sans-mesure" };
  const cote = coteMur(colonne, miroir);
  const debord = cote === "gauche" ? gauche : droite;
  const autre = cote === "gauche" ? droite : gauche;
  if (debord <= place)
    return { etat: "entre", debord, place, justesse: place - debord < JUSTESSE_MM };
  // La hauteur du côté vaut pour le côté que le rendu a reçu : après un miroir, elle attend le rendu suivant.
  const sensAJour = rapport.serre_livre_cote_mur === cote;
  const hauteurSens = sensAJour ? (rapport.serre_livre_hauteur_cote_mm ?? null) : null;
  if (autre <= place)
    return { etat: "retourner", debord, place, debordRetourne: autre, hauteurSens, sensAJour };
  const coteMax = rapport.serre_livre_hauteur_max_cote;
  const hauteurRetourne =
    coteMax != null && coteMax !== cote && coteMax !== "les deux"
      ? (rapport.serre_livre_hauteur_max_mm ?? null)
      : null;
  return { etat: "aucun-sens", debord, place, hauteurSens, sensAJour, hauteurRetourne };
}
